import React from 'react';
export function ImportanceOfToolingSection() {
  return <section data-id="element-2923">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2924">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2925">
          Importance of Tooling to HEM
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-2926">
        <p data-id="element-2927">
          Generally speaking, HEM is a matter of running the tool – not the tool
          itself. Virtually every tool can perform HEM, but using tooling built
          to withstand the rigors of HEM will result in greater success. While
          you can run a marathon in any type of shoes, you'd likely get the best
          results and performance from running shoes.
        </p>
        <p data-id="element-2928">
          HEM is often regarded as a machining method for larger diameter
          tooling because of the aggressive MRR of the operation and the
          fragility of tooling under 1/8" in size. However, miniature tooling
          can be used to achieve HEM, too.
        </p>
        <p data-id="element-2929">
          Using miniature tooling for HEM can create additional challenges that
          must be understood prior to beginning your operation.
        </p>

        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-6" data-id="element-2930">
          <h3 className="text-xl font-bold text-navy mb-4" data-id="element-2931">
            Best Tools for HEM:
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-2" data-id="element-2932">
            <li data-id="element-2933">High flute count for increased MRR.</li>
            <li data-id="element-2934">Large core diameter for added strength.</li>
            <li data-id="element-2935">
              Tool coating optimized for the workpiece material for increased
              lubricity.
            </li>
            <li data-id="element-2936">Variable Pitch/Variable Helix design for reduced harmonics.</li>
          </ul>
        </div>
      </div>
    </section>;
}